import { useCallback } from "react";
import { generatePath, useNavigate } from "react-router";

import type { DiscountLongTermInput } from "@/lib/gql/__generated__/graphql";

import { useCustomMutation } from "@/hooks/use-graphql-client";

import { PATHS } from "@/routes/paths";

import { notifyUserEventInfo } from "@/components/features/side-effect/notify-user-event-info";
import { useLoadingScreen } from "@/components/features/side-effect/show-loading-screen-to-user/_hooks/use-loading-screen";

import { DISCOUNT_LONG_TERM_FOR_LONG_TERM_STAY_CREATE_MUTATION } from "./schema";

export const useDiscountLongTermCreateMutation = () => {
	const navigate = useNavigate();
	const { mutationFunc } = useCustomMutation(DISCOUNT_LONG_TERM_FOR_LONG_TERM_STAY_CREATE_MUTATION);
	const { showLoadingScreenCallback, hideLoadingScreenCallback } = useLoadingScreen();

	const onCreateDiscountLongTerm = useCallback(
		async (input: DiscountLongTermInput) => {
			showLoadingScreenCallback();
			const { errors } = await mutationFunc({
				variables: { input },
			}).finally(() => {
				hideLoadingScreenCallback();
			});

			if (!errors) {
				notifyUserEventInfo({
					variant: "default",
					title: "連泊ディスカウントを作成しました",
				});
				navigate(generatePath(PATHS.HOTEL.ITEMS.DISCOUNT.TOP, { hotelID: input.hotelID }));
			}
		},
		[hideLoadingScreenCallback, mutationFunc, navigate, showLoadingScreenCallback],
	);

	return {
		onCreateDiscountLongTerm,
	};
};
